import React from 'react';
import { Link } from 'react-router-dom';
import { Mail, MapPin } from 'lucide-react';
import { FaXTwitter, FaLinkedin, FaInstagram } from 'react-icons/fa6';
import './PublicFooter.css';

const PublicFooter = () => {
  return (
    <footer className="public-footer">
      <div className="container">
        <div className="footer-content">
          {/* Brand Section */}
            {/* Brand Section */}
          <div className="footer-section footer-brand-section">
            <img src="/izzi.png" alt="IZZISHOWIN - Chicago Film Production Services" className="footer-logo" />
            <p className="footer-description">
              Your premier destination for production services, locations, equipment, and talent.
            </p>
            <div className="footer-socials">
              <a 
                href="https://x.com/izzishowin" 
                target="_blank" 
                rel="noopener noreferrer"
                className="social-link"
                aria-label="Twitter"
              >
                <FaXTwitter size={20} />
              </a>
              <a 
                href="https://www.linkedin.com/in/izzi-showin-12104339b/" 
                target="_blank" 
                rel="noopener noreferrer"
                className="social-link"
                aria-label="LinkedIn"
              >
                <FaLinkedin size={20} />
              </a>
              <a 
                href="https://www.instagram.com/izzishowin/" 
                target="_blank" 
                rel="noopener noreferrer"
                className="social-link"
                aria-label="Instagram"
              >
                <FaInstagram size={20} />
              </a>
            </div>
          </div>

          {/* Quick Links */}
          <div className="footer-section">
            <h4 className="footer-title">Quick Links</h4>
            <ul className="footer-links">
              <li><Link to="/">Home</Link></li>
              <li><Link to="/locations">Locations</Link></li>
              <li><Link to="/equipment">Equipment</Link></li>
              <li><Link to="/talent">Talent</Link></li>
              <li><Link to="/contact">Contact</Link></li>
              <li><Link to="/admin/login">Admin</Link></li>
            </ul>
          </div>

          {/* Services */}
          <div className="footer-section">
            <h4 className="footer-title">Services</h4>
            <ul className="footer-links">
              <li><Link to="/locations">Studio Rentals</Link></li>
              <li><Link to="/equipment">Equipment Rental</Link></li>
              <li><Link to="/talent">Talent Booking</Link></li>
              <li><Link to="/cart">Cart</Link></li>
            </ul>
          </div>

          {/* Contact Info */}
          <div className="footer-section">
            <h4 className="footer-title">Contact</h4>
            <ul className="footer-contact">
              <li>
                <Mail size={16} />
                <a href="mailto:info@izzishowin.com">info@izzishowin.com</a>
              </li>
              <li>
              </li>
              <li>
                <MapPin size={16} />
                <span>Chicago, IL</span>
              </li>
            </ul>
          </div>
        </div>

        {/* Footer Bottom */}
        <div className="footer-bottom">
          <p className="footer-copyright">
            © {new Date().getFullYear()} IZZISHOWIN. All rights reserved.
          </p>
        </div>
      </div>
    </footer>
  );
};

export default PublicFooter;